import { useCallback } from "react";
import { USER_MODULE_ACTION, useUserModuleDispatch, useUserModuleState } from "..";
import useGtagEvent from "../../../utils/google-analitics/use-gtag-event";

export default function useEndGame() {
    const dispatch = useUserModuleDispatch();
    const { gameEndSended, gameEnded, tracks } = useUserModuleState()
    const sendEvent = useGtagEvent()

    return useCallback(() => {

        if (!gameEnded) {
            dispatch({ type: USER_MODULE_ACTION.GAME_END })
        }

        if (!gameEndSended) {
            const complete = tracks.filter(t => t.status === 'completed').length;
            const lost = tracks.filter(t => t.status === 'lost').length;

            sendEvent('game_ends', `${complete}_${lost}`)
            dispatch({ type: USER_MODULE_ACTION.END_GAME_SENDED })
        }
    }, [gameEndSended, dispatch, sendEvent, gameEnded, tracks])
}
